export const getUtmInfo = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const campaignSource = queryParams.get('utm_source') || 'organic';
  const campaignMedium = queryParams.get('utm_medium') || 'organic';
  const adGroupCreative = queryParams.get('utm_campaign') || 'organic';
  const gclid = queryParams.get('gclid') || '';
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const landingPage = `${url.origin}${url.pathname}`;
  const conversionTrackingCode =
    queryParams.get('conversion_code') || 'organic';
  return {
    campaign_source: campaignSource,
    campaign_medium: campaignMedium,
    ad_group_creative: adGroupCreative,
    gclid: gclid,
    landing_page: landingPage,
    conversion_tracking_code: conversionTrackingCode,
  };
};
